import { enUS } from './en-us';
import { frFR } from './fr-fr';
import { itIT } from './it-it';

export const langs = {
    'en-us': enUS,
    'it-it': itIT,
    'fr-fr': frFR,
};
